import { SocialAuthProviders } from '@lfx/config';

export interface User {
  id: string;
  auth0Id: string;
  type: string;
  firstName: string;
  lastName: string;
  fullName: string;
  avatarUrl: string;
  timezone: string;
  emails: Email[];
  username: string;
  modifiedDate: string;
  createdDate: string;
  permissions: UserPermission[];
  socialAccounts?: Identity[];
  roles: [];
}

interface Identity {
  userId: string;
  provider: SocialAuthProviders;
  connection: string;
  isSocial: boolean;
}

interface UserPermission {
  context: string;
  actions: string[];
  allowed: boolean;
  resource: string;
  scopes: UserScope[];
}

interface UserScope {
  id: string[];
  role: string;
  type: string;
}

interface Email {
  emailAddress: string;
  emailType: string;
  active: boolean;
  isDeleted: boolean;
  isPrimary: boolean;
  isVerified?: boolean;
}
